exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group[data-v-2fa60008]{width:100%}.search-field[data-v-2fa60008]::-ms-clear{display:none}.search-clear[data-v-2fa60008]{position:absolute;right:0;top:0;bottom:0;padding:4px 8px 4px 4px;display:flex;align-items:center;font-weight:700;font-size:20px;color:#ccc;cursor:pointer}.search-clear[data-v-2fa60008]:hover{color:#999}", ""]);

// exports
